import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CategoryList from "../../components/home/CategoryList/CategoryList";
import HeroSection from "../../components/home/HeroSection/HeroSection";
import LoyaltySection from "../../components/home/LoyaltySection/LoyaltySection";
import UserProfileSection from "../../components/home/UserProfileSection/UserProfileSection";
import RestaurantsMapSection from "../../components/home/RestaurantsMapSection/RestaurantsMapSection";
import { useConfig } from "../../context/ConfigContext";
import { Category, Restaurant } from "../../interfaces/Catalogue";
import { UserInfo } from "../../interfaces/user";
import { catalogueApi } from "../../services/catalogueApi";
import { getmyprofile, setSelectedRestaurant } from "../../store/actions/actions";
import { RootState } from "../../store/rootState";
import Footer from "../../components/shared/Footer/Footer";
import { fetchEstablishementToken } from "../../hooks/useAppInit";
import GoogleMapsReviewCTA from "../../components/home/GoogleMapsReviewCTA/GoogleMapsReviewCTA";
import styles from "./HomePage.module.scss";

const HomePage: React.FC = () => {
  const { config } = useConfig();
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");

  const restaurants = useSelector((state: RootState) => state.shop.shops);
  const selectedRestaurant = useSelector(
    (state: RootState) => state.shop.selectedRestaurant
  );
  const userInfo: UserInfo = useSelector(
    (state: RootState) => state.auth.userInfo
  );

  const [establishementToken, setEstablishementToken] = useState<string>(
    localStorage.getItem("establishementToken") || ""
  );
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (accessToken) dispatch(getmyprofile());
  }, [accessToken]);

  useEffect(() => {
    const fetchToken = async () => {
      if (selectedRestaurant?.id) {
        const token = await fetchEstablishementToken(selectedRestaurant.id);
        setEstablishementToken(token);
      }
    };
    fetchToken();
  }, [selectedRestaurant?.id]);

  useEffect(() => {
    if (selectedRestaurant?.id && establishementToken) {
      fetchCategories(selectedRestaurant.id);
    }
  }, [selectedRestaurant?.id, establishementToken]);

  const fetchCategories = async (restaurantId: number): Promise<void> => {
    try {
      setLoading(true);
      const response = await catalogueApi.getCategories(restaurantId);
      setCategories(response.data.data.result || []);
    } catch (error) {
      setCategories([]);
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectRestaurant = (restaurant: Restaurant) => {
    dispatch(setSelectedRestaurant(restaurant));
  };

  return (
    <div className={styles.homePage}>
      <div className={styles.homeContainer}>
        <HeroSection
          restaurant={selectedRestaurant}
          restaurants={restaurants}
          onSelectRestaurant={(restaurant: Restaurant) => {
            dispatch(setSelectedRestaurant(restaurant));
          }}
        />

        <div className={styles.contentContainer}>
          {selectedRestaurant && <LoyaltySection />}

          {config?.showCommandEnLigne && (
            <CategoryList categories={categories} loading={loading} />
          )}

          {restaurants?.length > 0 && (
            <RestaurantsMapSection
              restaurants={restaurants}
              selectedRestaurant={selectedRestaurant}
              onSelectRestaurant={handleSelectRestaurant}
            />
          )}


          <GoogleMapsReviewCTA />

          <div className={styles.userProfileSection}>
            <UserProfileSection userInfo={userInfo} />
          </div>
          <div className={styles.bottomSpacer} />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;